// src/utils/ticketUtils.js
import { STATUS_CLASSES, PRIORITY_CLASSES } from '../constants';

export function getStatusClass(status) {
  if (!status) return '';
  return STATUS_CLASSES[status.toUpperCase()] || 'status-todo';
}

export function getPriorityClass(priority) {
  if (!priority) return '';
  return PRIORITY_CLASSES[priority.toUpperCase()] || '';
}

export function formatTicketKey(key) {
  return key || 'No Key';
}

export function formatTicketSummary(summary) {
  return summary || 'No summary available';
}

export function formatTicketDescription(description) {
  return description || 'No description provided';
}

export function formatCategory(category) {
  return category || 'Uncategorized';
}

export function formatInitialEffortEstimations(effort) {
  if (!effort || effort <= 0) return 'Not estimated';
  return `${effort} ${effort === 1 ? 'day' : 'days'}`;
}

// ✅ Add the missing function
export function isTodayInSprint(sprintName, startSprint = 88, baseDate = '2024-07-01') {
  const sprintNumber = parseInt(sprintName.split(' ')[1], 10);
  const base = new Date(baseDate);

  const weeksToAdd = sprintNumber - startSprint;
  const devStart = new Date(base);
  devStart.setDate(devStart.getDate() + weeksToAdd * 14);
  const devEnd = new Date(devStart);
  devEnd.setDate(devStart.getDate() + 13);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return today >= devStart && today <= devEnd;
}

export function exportTicketsToCSV(tickets, filename = 'tickets_export.csv') {
  // Define the CSV headers - UPDATED WITH NEW FIELDS
  const headers = [
    'Issue Key',
    'Summary', 
    'Description',
    'Status',
    'Priority',
    'Category', // ✅ NEW FIELD
    'Initial Effort Estimations', // ✅ NEW FIELD
    'Sprint',
    'Order',
    'Assignee',
    'Component',
    'Labels',
    'Due Date',
    'Story Points',
    'Created At',
    'Updated At'
  ];

  // Convert tickets to CSV format - UPDATED WITH NEW FIELDS
  const csvData = tickets.map(ticket => [
    ticket.issue_key || '',
    ticket.summary || '',
    ticket.description || '',
    ticket.status || '',
    ticket.priority || '',
    ticket.category || '', // ✅ NEW FIELD
    ticket.initial_effort_estimations || '', // ✅ NEW FIELD (will be empty string if null/undefined)
    ticket.sprint || 'Unassigned',
    ticket.order || '',
    ticket.assignee || '',
    ticket.component || '',
    ticket.labels || '',
    ticket.due_date ? new Date(ticket.due_date).toLocaleDateString() : '',
    ticket.story_points || '',
    ticket.created_at ? new Date(ticket.created_at).toLocaleDateString() : '',
    ticket.updated_at ? new Date(ticket.updated_at).toLocaleDateString() : ''
  ]);

  // Combine headers and data
  const allRows = [headers, ...csvData];

  // Convert to CSV string
  const csvContent = allRows.map(row => 
    row.map(field => {
      // Escape quotes and wrap in quotes if contains comma, quote, or newline
      const escaped = String(field).replace(/"/g, '""');
      return escaped.includes(',') || escaped.includes('"') || escaped.includes('\n') 
        ? `"${escaped}"` 
        : escaped;
    }).join(',')
  ).join('\n');

  // Create and download the file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}